<template>
  <div class="mx-5 mt-5">
    <v-card>
      <v-toolbar color="indigo" dense>
        <v-toolbar-title class="white--text"> Label Overview </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri == false"
              @click="clickShowFilters"
              class="mr-4"
              small
              v-bind="attrs"
              v-on="on"
            >
              <v-icon color="purple lighter-2"> mdi-filter </v-icon>
            </v-btn>
          </template>
          <span>Show filters</span>
        </v-tooltip>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-show="show_filtri === true"
              @click="resetFiltro"
              small
              v-bind="attrs"
              v-on="on"
              ><v-icon color="purple lighter-2">mdi-filter-off</v-icon></v-btn
            >
          </template>
          <span>Hide filters</span>
        </v-tooltip>

        <v-spacer></v-spacer>

        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn small @click="goBack" v-bind="attrs" v-on="on">
              <v-icon color="error"> mdi-keyboard-backspace </v-icon>
            </v-btn>
          </template>
          <span>Back</span>
        </v-tooltip>
      </v-toolbar>
      <v-card-text id="mainCardText" class="mt-3">
        <v-row align="center" justify="center" v-if="show_filtri">
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.cod_articolo"
              :item-value="(item) => item.cod_articolo"
              label="Item Code"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_search == "" ? "mdi-filter" : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.cod_label"
              :item-value="(item) => item.cod_label"
              label="Label Code"
              style="display: inline-block; max-width: 350px"
              v-model="label_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    label_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{ label_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.cod_articolo_packaging"
              :item-value="(item) => item.cod_articolo_packaging"
              label="Packaging Code"
              style="display: inline-block; max-width: 350px"
              v-model="cod_articolo_packaging_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    cod_articolo_packaging_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    cod_articolo_packaging_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="lista_etichette.filter((i) => i.cod_articolo != null)"
              :item-text="(item) => item.ragione_sociale"
              :item-value="(item) => item.ragione_sociale"
              label="Partner"
              style="display: inline-block; max-width: 350px"
              v-model="ragione_sociale_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    ragione_sociale_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{
                    ragione_sociale_search == ""
                      ? "mdi-filter"
                      : "mdi-filter-off"
                  }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>

          <v-col>
            <v-autocomplete
              background-color="#ffffff"
              @change="filtra"
              dense
              hide-details
              :items="stato_list"
              :item-text="(item) => item.des"
              :item-value="(item) => item.value"
              label="Status"
              style="display: inline-block; max-width: 350px"
              v-model="stato_search"
            >
              <template v-slot:append>
                <v-icon
                  class="ml-2"
                  @click="
                    stato_search = '';
                    filtra();
                  "
                  color="primary"
                  >{{ stato_search == "" ? "mdi-filter" : "mdi-filter-off" }}
                </v-icon>
              </template>
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-data-table :items="lista_tabella" :headers="headers_etichette">
          <!-- Bottone dialog di dettaglio -->
          <template v-slot:[`item.dettaglio`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickShowDetail(item)"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="primary"> mdi-magnify </v-icon>
                </v-btn>
              </template>
              <span>Show detail</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.des_stato`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="
                    item.des_stato == 'APPROVED'
                      ? 'success'
                      : item.des_stato == 'REFUSED'
                      ? 'error'
                      : item.des_stato == 'IN EDIT'
                      ? 'yellow'
                      : item.des_stato == 'TO BE APPROVED'
                      ? 'orange'
                      : ''
                  "
                  >{{
                    item.des_stato == "APPROVED"
                      ? "mdi-check-circle"
                      : item.des_stato == "REFUSED"
                      ? "mdi-close-circle"
                      : item.des_stato == "IN EDIT"
                      ? "mdi-pencil-circle"
                      : item.des_stato == "TO BE APPROVED"
                      ? "mdi-play-speed"
                      : ""
                  }}</v-icon
                >
              </template>
              <span>
                {{
                  item.des_stato == "APPROVED"
                    ? "APPROVED"
                    : item.des_stato == "REFUSED"
                    ? "REFUSED"
                    : item.des_stato == "IN EDIT"
                    ? "IN EDIT"
                    : item.des_stato == "TO BE APPROVED"
                    ? "TO BE APPROVED"
                    : ""
                }}
              </span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>

      <!-- Snackbar -->
      <SnackbarQV ref="SnackbarQV" />
    </v-card>

    <!-- Dialog Dettaglio Tartuflanghe -->
    <v-dialog
      :key="key_reportpage"
      persistent
      v-model="dialog_show_detail"
      width="90%"
    >
      <div style="overflow: hidden">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title
              >Approvazione - {{ label.cod_label }} -
              {{ label.ragione_sociale }}</v-toolbar-title
            >

            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="label.stato != 1"
                  @click="clickNonApprova"
                  small
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="error"> mdi-circle-off-outline </v-icon>
                </v-btn>
              </template>
              <span>Reject</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  :disabled="label.stato != 1"
                  @click="clickApprova"
                  small
                  style="margin-right: 220px; margin-left: 20px"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon color="success"> mdi-check </v-icon>
                </v-btn>
              </template>
              <span>Approve</span>
            </v-tooltip>

            <!-- <v-spacer></v-spacer>

            <v-btn
              :disabled="label.stato != 1"
              small
              @click="clickNonApprova"
              color="error"
              class="mr-4"
              >REJECT</v-btn
            >
            <v-btn
              small
              :disabled="label.stato != 1"
              @click="clickApprova"
              color="success"
              >APPROVE
            </v-btn> -->

            <v-spacer></v-spacer>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  @click="clickChiudiDialogDetail"
                  v-bind="attrs"
                  v-on="on"
                  small
                >
                  <v-icon color="error">mdi-close</v-icon>
                </v-btn>
              </template>
              <span>Close</span>
            </v-tooltip>
          </v-toolbar>
          <v-row align="center" justify="center" class="ma-2">
            <v-col>
              <QuickLabelDetail
                ref="label_detail"
                :etichetta="label.modello"
                :show_off="true"
                :show_tab_off="true"
                :key="key_reportpage"
              />
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-dialog>

    <!-- Dialog Approvazione Tartuflanghe -->
    <v-dialog persistent v-model="dialog_approvazione" width="40%">
      <div style="overflow: hidden">
        <v-card>
          <v-toolbar dense color="indigo" class="white--text">
            <v-toolbar-title>Conferma</v-toolbar-title>
          </v-toolbar>
          <v-row>
            <v-col>
              <v-row
                v-if="non_approva"
                align="center"
                justify="center"
                class="ma-4"
              >
                Sei sicuro di voler rifiutare le modifiche dell'etichetta?
              </v-row>
              <v-row
                v-if="approva"
                align="center"
                justify="center"
                class="ma-4"
              >
                Sei sicuro di voler approvare le modifiche dell'etichetta?
              </v-row>
              <v-divider></v-divider>
              <v-row align="center" justify="center" class="ma-2">
                <v-col>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="mr-2"
                        @click="clickChiudiDialogAppr"
                        v-bind="attrs"
                        v-on="on"
                        small
                      >
                        <v-icon color="error">mdi-close</v-icon>
                      </v-btn>
                    </template>
                    <span>Close</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        @click="confermaApprovazione"
                        v-bind="attrs"
                        v-on="on"
                        small
                      >
                        <v-icon color="success">mdi-check</v-icon>
                      </v-btn>
                    </template>
                    <span>Save</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-card>
      </div>
    </v-dialog>
  </div>
</template>
<script>
import SnackbarQV from "@/components/TOOLS/SnackbarQV.vue";
import { FrxToJson } from "./FrxJsonConverter";
import QuickLabelDetail from "@/views/LABEL/QuickLabelDetail";

class Label {
  constructor(arg = undefined) {
    if (arg != undefined) {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = arg[c.nome] != undefined ? arg[c.nome] : c.default_val;
      });
    } else {
      const campi = this.setControlli();
      campi.forEach((c) => {
        this[c.nome] = c.default_val;
      });
    }
  }

  // Metodo per resettare tutte i campi
  reset() {
    const campi = this.setControlli();
    campi.forEach((c) => {
      this[c.nome] = c.default_val;
    });
  }

  setControlli() {
    const campi = [
      { nome: "id_label", default_val: -1 },
      { nome: "id_articolo_packaging_label", default_val: null },
      { nome: "new_master", default_val: false },
      { nome: "cod_label", default_val: "" },
      { nome: "modello", default_val: null },
      { nome: "base64", default_val: "" },
      { nome: "campi", default_val: [] },
      { nome: "root", default_val: "" },
      { nome: "ragione_sociale", default_val: "" },
      { nome: "stato", default_val: null },
      { nome: "des_stato", default_val: "" },
      { nome: "validita", default_val: 1 },
    ];
    return campi;
  }
}

export default {
  name: "",
  components: {
    SnackbarQV,
    QuickLabelDetail,
  },
  props: {},
  data() {
    return {
      // Variabili d'appoggio
      cod_articolo_search: "",
      cod_articolo_packaging_search: "",
      key_reportpage: 0,
      label: new Label(),
      label_search: "",
      stato_search: "",
      ragione_sociale_search: "",

      // Modal
      approva: false,
      dialog_add: false,
      dialog_approvazione: false,
      dialog_show_detail: false,
      non_approva: false,
      show_filtri: true,

      // Array
      lista_etichette: [],
      stato_list: [
        // {
        //   des: "IN EDIT",
        //   value: 4,
        // },
        {
          des: "TO BE APPROVED",
          value: 1,
        },
        {
          des: "APPROVED",
          value: 2,
        },
        {
          des: "REFUSED",
          value: 3,
        },
      ],
      lista_tabella: [],
      headers_etichette: [
        {
          text: "Detail",
          value: "dettaglio",
          sortable: false,
          align: "center",
        },
        {
          text: "Item Code",
          value: "cod_articolo",
          sortable: false,
        },
        {
          text: "Item Des.",
          value: "des_articolo",
          sortable: false,
        },
        {
          text: "Label Code",
          value: "cod_label",
        },

        {
          text: "Packaging Code",
          value: "cod_articolo_packaging",
        },
        {
          text: "Partner",
          value: "ragione_sociale",
        },

        {
          text: "Version",
          value: "versione",
        },
        {
          text: "Status",
          value: "des_stato",
        },
      ],
    };
  },
  computed: {},
  methods: {
    clickChiudiDialogAppr() {
      this.non_approva = false;
      this.approva = false;
      this.dialog_approvazione = false;
    },
    clickChiudiDialogAgg() {
      this.e1 = 1;
      this.dialog_add = false;
    },

    clickChiudiDialogDetail() {
      this.label = new Label();
      this.dialog_show_detail = false;
    },
    clickApprova() {
      this.approva = true;
      this.dialog_approvazione = true;
    },
    clickNonApprova() {
      this.non_approva = true;
      this.dialog_approvazione = true;
    },
    clickShowFilters() {
      this.show_filtri = true;
    },
    async clickShowDetail(item) {
      this.label = new Label(item);
      await this.getLabelDetail(item);

      this.$nextTick(() => {
        this.key_reportpage = this.key_reportpage == 0 ? 1 : 0;
      });

      this.dialog_show_detail = true;
    },
    confermaApprovazione() {
      const request = {
        controller: "Label",
        method: "PUT",
        richiesta: {
          action: "updatelabelstatus",
          token: localStorage.user_token,
          status: this.non_approva ? 3 : 2,
          id_articolo_packaging_label: this.label.id_articolo_packaging_label,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          console.log(res);
          this.getLabel();
          this.label = new Label();
          this.dialog_approvazione = false;
          this.non_approva = false;
          this.approva = false;
          this.dialog_confirm = false;
          this.dialog_show_detail = false;
          this.$refs.SnackbarQV.print("success", "Label salvato con successo");
        })
        .catch((err) => {
          this.approva = false;
          this.non_approva = false;
          this.label = new Label();
          this.dialog_approvazione = false;
          this.dialog_confirm = false;
          this.dialog_show_detail = false;
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getLabel() {
      const request = {
        controller: "Label",
        method: "POST",
        richiesta: {
          action: "getlabelstatuses",
          token: localStorage.user_token,
        },
      };

      this.$store
        .dispatch("api", request)
        .then((res) => {
          if (res.status === 200) {
            this.lista_etichette = res.data;
            this.lista_tabella = this.lista_etichette;
            this.lista_tabella.map((el) => {
              switch (el.stato) {
                case 0:
                  el.des_stato = "IN EDIT";
                  break;
                case 1:
                  el.des_stato = "TO BE APPROVED";
                  break;
                case 2:
                  el.des_stato = "APPROVED";
                  break;
                case 3:
                  el.des_stato = "REFUSED";
                  break;

                default:
                  break;
              }
            });
            this.setVarStatus();
          } else {
            this.$refs.SnackbarQV.print(
              "orange",
              `Criticità rilevata, codice stato: ${res.status}.`
            );
          }
        })
        .catch((err) => {
          this.$refs.SnackbarQV.print(
            "error",
            `${JSON.parse(err.response.data.message).result}.`
          );
        });
    },
    getLabelDetail(item) {
      return new Promise((resolve, reject) => {
        const request = {
          controller: "Label",
          method: "POST",
          richiesta: {
            action: "getlabeldetail",
            token: localStorage.user_token,
            id_versione_articolo_packaging_label:
              item.id_versione_articolo_packaging_label,
          },
        };

        this.$store
          .dispatch("api", request)
          .then((res) => {
            if (res.status === 200) {
              this.label.base64 = res.data.label[0].modello;
              this.label.modello = FrxToJson(this.label.base64);
            } else {
              this.$refs.SnackbarQV.print(
                "orange",
                `Criticità rilevata, codice stato: ${res.status}.`
              );
            }
            resolve();
          })
          .catch((err) => {
            this.$refs.SnackbarQV.print(
              "error",
              `${JSON.parse(err.response.data.message).result}.`
            );
            reject(err);
          });
      });
    },
    goBack() {
      this.$router.push("/home");
    },

    filtra() {
      let items_etichette_tmp = [];
      this.lista_etichette.forEach((elem) => {
        items_etichette_tmp.push(elem);
      });

      // Filtro il nome della intervento
      if (this.cod_articolo_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.cod_articolo == this.cod_articolo_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      // Filtro il nome della intervento
      if (this.cod_articolo_packaging_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (
            elem.cod_articolo_packaging == this.cod_articolo_packaging_search
          ) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      if (this.ragione_sociale_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.ragione_sociale == this.ragione_sociale_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.stato_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.stato == this.stato_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }
      if (this.label_search != "") {
        // Faccio un array temporaneo
        const res = [];
        /* Filtro gli elementi visualizzati dopo i passaggi precedenti
         * e li inserisco in "res". */
        items_etichette_tmp.forEach((elem) => {
          if (elem.cod_label == this.label_search) {
            res.push(elem);
          }
        });
        // Modello la risposta provvisoria su "res".
        items_etichette_tmp = res;
      }

      this.lista_tabella = items_etichette_tmp;
    },
    resetFiltro() {
      // Resetto i filtri
      this.cod_articolo_search = "";
      this.stato_search = "";
      this.label_search = "";
      this.cod_articolo_packaging_search = "";
      this.ragione_sociale_search = "";

      // Nascondo i filtri
      this.show_filtri = false;

      this.lista_tabella = this.lista_etichette;
    },
    setVarStatus() {
      this.stato_search = 1;
      this.filtra();
    },
  },
  created() {},
  mounted() {
    this.getLabel();
  },
  watch: {},
};
</script>
<style scoped>
</style>